import React from "react";
import { useDispatch } from "react-redux";
// import { db } from "../firebase";
import { push } from "connected-react-router";
import { GenreList } from "../components/map";

const BoothMap = () => {
  const dispatch = useDispatch();
  //   const [users, setUsers] = useState([]);

  //本来の手順
  //Firestoreのboothを日付で当日だけフィルターをかける
  //その中のboothID,boothName,organizerName,ブース説明とuidを取得
  //uidからアバター画像とジャンルを取得
  //それをまとめて連想配列にする
  const getOrganizers = [
    {
      boothID: "3NQdx1bQAEwJHhypFBEN",
      boothName: "ジャスト ライク ミー",
      organizerName: "山本奈奈",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2FkJCWUAo.jpg?alt=media&token=0c5b7c01-de7b-4429-82ea-e60b9c561073",
      description:
        "「アースタ」の愛称で親しまれている都市型のアートとクラフトの祭典「東京アートクラフトフェスタ」は、いま再開発で注目を集める東京「浜松町・竹芝」のベイエリアで開催！今回はイベント内容を拡大して初の2days開催となります。土曜日は全国から様々なハンドメイド作家・アーティストが作品を展示販売する「手作りマルシェDAY」、日曜日はアートやクラフトのホビーに関連するブースを集めた「クラフトホビーDAY」として、1日ずつテーマを変えて開催いたします。  ハンドメイド作品、道具・材料の展示販売のほか、体験コーナー、デモンストレーション、ワークショップなどアート＆クラフトの「新しい発見」に出会えるイベントです。どうぞお楽しみに！",
      genre: "油絵作家",
    },
    {
      boothID: "3NQdx1bQAEwJHhypFBEN",
      boothName: "ジャスト ライク ミー",
      organizerName: "山本奈奈",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2FkJCWUAo.jpg?alt=media&token=0c5b7c01-de7b-4429-82ea-e60b9c561073",
      description:
        "「アースタ」の愛称で親しまれている都市型のアートとクラフトの祭典「東京アートクラフトフェスタ」は、いま再開発で注目を集める東京「浜松町・竹芝」のベイエリアで開催！今回はイベント内容を拡大して初の2days開催となります。土曜日は全国から様々なハンドメイド作家・アーティストが作品を展示販売する「手作りマルシェDAY」、日曜日はアートやクラフトのホビーに関連するブースを集めた「クラフトホビーDAY」として、1日ずつテーマを変えて開催いたします。  ハンドメイド作品、道具・材料の展示販売のほか、体験コーナー、デモンストレーション、ワークショップなどアート＆クラフトの「新しい発見」に出会えるイベントです。どうぞお楽しみに！",
      genre: "油絵作家",
    },
    {
      boothID: "3NQdx1bQAEwJHhypFBEN",
      boothName: "ジャスト ライク ミー",
      organizerName: "山本奈奈",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2FkJCWUAo.jpg?alt=media&token=0c5b7c01-de7b-4429-82ea-e60b9c561073",
      description:
        "「アースタ」の愛称で親しまれている都市型のアートとクラフトの祭典「東京アートクラフトフェスタ」は、いま再開発で注目を集める東京「浜松町・竹芝」のベイエリアで開催！今回はイベント内容を拡大して初の2days開催となります。土曜日は全国から様々なハンドメイド作家・アーティストが作品を展示販売する「手作りマルシェDAY」、日曜日はアートやクラフトのホビーに関連するブースを集めた「クラフトホビーDAY」として、1日ずつテーマを変えて開催いたします。  ハンドメイド作品、道具・材料の展示販売のほか、体験コーナー、デモンストレーション、ワークショップなどアート＆クラフトの「新しい発見」に出会えるイベントです。どうぞお楽しみに！",
      genre: "油絵作家",
    },
    {
      boothID: "3NQdx1bQAEwJHhypFBEN",
      boothName: "ジャスト ライク ミー",
      organizerName: "山本奈奈",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2FkJCWUAo.jpg?alt=media&token=0c5b7c01-de7b-4429-82ea-e60b9c561073",
      description:
        "「アースタ」の愛称で親しまれている都市型のアートとクラフトの祭典「東京アートクラフトフェスタ」は、いま再開発で注目を集める東京「浜松町・竹芝」のベイエリアで開催！今回はイベント内容を拡大して初の2days開催となります。土曜日は全国から様々なハンドメイド作家・アーティストが作品を展示販売する「手作りマルシェDAY」、日曜日はアートやクラフトのホビーに関連するブースを集めた「クラフトホビーDAY」として、1日ずつテーマを変えて開催いたします。  ハンドメイド作品、道具・材料の展示販売のほか、体験コーナー、デモンストレーション、ワークショップなどアート＆クラフトの「新しい発見」に出会えるイベントです。どうぞお楽しみに！",
      genre: "油絵作家",
    },
    {
      boothID: "3NQdx1bQAEwJHhypFBEN",
      boothName: "ジャスト ライク ミー",
      organizerName: "山本奈奈",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2FkJCWUAo.jpg?alt=media&token=0c5b7c01-de7b-4429-82ea-e60b9c561073",
      description:
        "「アースタ」の愛称で親しまれている都市型のアートとクラフトの祭典「東京アートクラフトフェスタ」は、いま再開発で注目を集める東京「浜松町・竹芝」のベイエリアで開催！今回はイベント内容を拡大して初の2days開催となります。土曜日は全国から様々なハンドメイド作家・アーティストが作品を展示販売する「手作りマルシェDAY」、日曜日はアートやクラフトのホビーに関連するブースを集めた「クラフトホビーDAY」として、1日ずつテーマを変えて開催いたします。  ハンドメイド作品、道具・材料の展示販売のほか、体験コーナー、デモンストレーション、ワークショップなどアート＆クラフトの「新しい発見」に出会えるイベントです。どうぞお楽しみに！",
      genre: "油絵作家",
    },
    {
      boothID: "OyZAJaVIihbl8NGFVGYb",
      boothName: "宇宙の暮らし",
      organizerName: "小林尊",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2F9vLfhK9h.jpg?alt=media&token=b941bc9c-d85b-4cee-ac14-531277a36d44",
      description:
        "土曜日「手作りマルシェDAY」では、全国各地からハンドメイド作家やアーティストが集結します。 かわいいクラフト雑貨やオリジナルの文具、世界にひとつしか存在しないアクセサリーなどが並びます。  まるで宝探しに出かけるようなワクワクの1日をお楽しみください。 ココロときめく光かがやく素敵なハンドメイド作品を集めた「きらきらクラフトアヴェニュー」ゾーン、かわいい猫モチーフの雑貨を集めた「浜松町にゃんこ雑貨横丁」ゾーンなど、企画ゾーンもあります！",
      genre: "イラストレーター",
    },
    {
      boothID: "OyZAJaVIihbl8NGFVGYb",
      boothName: "宇宙の暮らし",
      organizerName: "小林尊",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2FVUMBKh1U.jpg?alt=media&token=fd9691cc-0930-4ae8-bdc0-1f2fb2ae0578",
      description:
        "土曜日「手作りマルシェDAY」では、全国各地からハンドメイド作家やアーティストが集結します。 かわいいクラフト雑貨やオリジナルの文具、世界にひとつしか存在しないアクセサリーなどが並びます。  まるで宝探しに出かけるようなワクワクの1日をお楽しみください。 ココロときめく光かがやく素敵なハンドメイド作品を集めた「きらきらクラフトアヴェニュー」ゾーン、かわいい猫モチーフの雑貨を集めた「浜松町にゃんこ雑貨横丁」ゾーンなど、企画ゾーンもあります！",
      genre: "イラストレーター",
    },
    {
      boothID: "OyZAJaVIihbl8NGFVGYb",
      boothName: "宇宙の暮らし",
      organizerName: "小林尊",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2FVUMBKh1U.jpg?alt=media&token=fd9691cc-0930-4ae8-bdc0-1f2fb2ae0578",
      description:
        "土曜日「手作りマルシェDAY」では、全国各地からハンドメイド作家やアーティストが集結します。 かわいいクラフト雑貨やオリジナルの文具、世界にひとつしか存在しないアクセサリーなどが並びます。  まるで宝探しに出かけるようなワクワクの1日をお楽しみください。 ココロときめく光かがやく素敵なハンドメイド作品を集めた「きらきらクラフトアヴェニュー」ゾーン、かわいい猫モチーフの雑貨を集めた「浜松町にゃんこ雑貨横丁」ゾーンなど、企画ゾーンもあります！",
      genre: "イラストレーター",
    },
    {
      boothID: "OyZAJaVIihbl8NGFVGYb",
      boothName: "宇宙の暮らし",
      organizerName: "小林尊",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2FVUMBKh1U.jpg?alt=media&token=fd9691cc-0930-4ae8-bdc0-1f2fb2ae0578",
      description:
        "土曜日「手作りマルシェDAY」では、全国各地からハンドメイド作家やアーティストが集結します。 かわいいクラフト雑貨やオリジナルの文具、世界にひとつしか存在しないアクセサリーなどが並びます。  まるで宝探しに出かけるようなワクワクの1日をお楽しみください。 ココロときめく光かがやく素敵なハンドメイド作品を集めた「きらきらクラフトアヴェニュー」ゾーン、かわいい猫モチーフの雑貨を集めた「浜松町にゃんこ雑貨横丁」ゾーンなど、企画ゾーンもあります！",
      genre: "イラストレーター",
    },
    {
      boothID: "OyZAJaVIihbl8NGFVGYb",
      boothName: "宇宙の暮らし",
      organizerName: "小林尊",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2FVUMBKh1U.jpg?alt=media&token=fd9691cc-0930-4ae8-bdc0-1f2fb2ae0578",
      description:
        "土曜日「手作りマルシェDAY」では、全国各地からハンドメイド作家やアーティストが集結します。 かわいいクラフト雑貨やオリジナルの文具、世界にひとつしか存在しないアクセサリーなどが並びます。  まるで宝探しに出かけるようなワクワクの1日をお楽しみください。 ココロときめく光かがやく素敵なハンドメイド作品を集めた「きらきらクラフトアヴェニュー」ゾーン、かわいい猫モチーフの雑貨を集めた「浜松町にゃんこ雑貨横丁」ゾーンなど、企画ゾーンもあります！",
      genre: "イラストレーター",
    },
    {
      boothID: "iuv7nqWfP3EwkrJlzeMH",
      boothName: "プリントザウルス国際版画交流協会展示",
      organizerName: "つのだひろ",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2FVUMBKh1U.jpg?alt=media&token=fd9691cc-0930-4ae8-bdc0-1f2fb2ae0578",
      description:
        "日曜日「クラフトホビーDAY」には、造る・彫る・切る・削る・描く・捺すをテーマにしたクラフトホビーに関連する企業やショップ、クリエイターが大集合します。ハンドメイド作品や材料・素材・道具の展示販売や体験ワークショップなど、新しいクラフトホビーにも出会える1日です。  消しゴムはんこ作家が多く出展する「けしごむはんこヴィレッジ」ゾーン、海外で人気のスタンプアート系が集まる「スタンプワンダーランドmini」ゾーン、物作り体験を楽しめる「体験ワークショップ」ゾーンがあります。",
      genre: "水彩画",
    },
    {
      boothID: "iuv7nqWfP3EwkrJlzeMH",
      boothName: "プリントザウルス国際版画交流協会展示",
      organizerName: "つのだひろ",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2F1H_7AxP0.jpg?alt=media&token=2fa04f27-7c33-436f-922f-97ab67fd8cb2",
      description:
        "日曜日「クラフトホビーDAY」には、造る・彫る・切る・削る・描く・捺すをテーマにしたクラフトホビーに関連する企業やショップ、クリエイターが大集合します。ハンドメイド作品や材料・素材・道具の展示販売や体験ワークショップなど、新しいクラフトホビーにも出会える1日です。  消しゴムはんこ作家が多く出展する「けしごむはんこヴィレッジ」ゾーン、海外で人気のスタンプアート系が集まる「スタンプワンダーランドmini」ゾーン、物作り体験を楽しめる「体験ワークショップ」ゾーンがあります。",
      genre: "水彩画",
    },
    {
      boothID: "iuv7nqWfP3EwkrJlzeMH",
      boothName: "プリントザウルス国際版画交流協会展示",
      organizerName: "つのだひろ",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2F1H_7AxP0.jpg?alt=media&token=2fa04f27-7c33-436f-922f-97ab67fd8cb2",
      description:
        "日曜日「クラフトホビーDAY」には、造る・彫る・切る・削る・描く・捺すをテーマにしたクラフトホビーに関連する企業やショップ、クリエイターが大集合します。ハンドメイド作品や材料・素材・道具の展示販売や体験ワークショップなど、新しいクラフトホビーにも出会える1日です。  消しゴムはんこ作家が多く出展する「けしごむはんこヴィレッジ」ゾーン、海外で人気のスタンプアート系が集まる「スタンプワンダーランドmini」ゾーン、物作り体験を楽しめる「体験ワークショップ」ゾーンがあります。",
      genre: "水彩画",
    },
    {
      boothID: "iuv7nqWfP3EwkrJlzeMH",
      boothName: "プリントザウルス国際版画交流協会展示",
      organizerName: "つのだひろ",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2F9vLfhK9h.jpg?alt=media&token=b941bc9c-d85b-4cee-ac14-531277a36d44",
      description:
        "日曜日「クラフトホビーDAY」には、造る・彫る・切る・削る・描く・捺すをテーマにしたクラフトホビーに関連する企業やショップ、クリエイターが大集合します。ハンドメイド作品や材料・素材・道具の展示販売や体験ワークショップなど、新しいクラフトホビーにも出会える1日です。  消しゴムはんこ作家が多く出展する「けしごむはんこヴィレッジ」ゾーン、海外で人気のスタンプアート系が集まる「スタンプワンダーランドmini」ゾーン、物作り体験を楽しめる「体験ワークショップ」ゾーンがあります。",
      genre: "水彩画",
    },
    {
      boothID: "iuv7nqWfP3EwkrJlzeMH",
      boothName: "プリントザウルス国際版画交流協会展示",
      organizerName: "辻あかり",
      avatar:
        "https://firebasestorage.googleapis.com/v0/b/time-booth.appspot.com/o/users%2F9vLfhK9h.jpg?alt=media&token=b941bc9c-d85b-4cee-ac14-531277a36d44",
      description:
        "日曜日「クラフトホビーDAY」には、造る・彫る・切る・削る・描く・捺すをテーマにしたクラフトホビーに関連する企業やショップ、クリエイターが大集合します。ハンドメイド作品や材料・素材・道具の展示販売や体験ワークショップなど、新しいクラフトホビーにも出会える1日です。  消しゴムはんこ作家が多く出展する「けしごむはんこヴィレッジ」ゾーン、海外で人気のスタンプアート系が集まる「スタンプワンダーランドmini」ゾーン、物作り体験を楽しめる「体験ワークショップ」ゾーンがあります。",
      genre: "水彩画",
    },
  ];

  return (
    <section className="c-section-wrapin">
      <div className="center">
        <button onClick={() => dispatch(push("/"))}>ホームへ</button>
        <h2>ブースマップ画面</h2>
        <GenreList organizers={getOrganizers} />
      </div>
      <div></div>
    </section>
  );
};

export default BoothMap;
